/**
 * Filters out option groups that should not appear on the main product pages
 * (they will be selected later in the Order Product Options flow),
 * such as Gift Box Sleeves and Cake Image options.
 *
 * @param {Array} options - Full product options array
 * @returns {Array} - Options with sleeve and cake image groups removed
 */
export const filterOutOrderProductOptions = (options = []) => {
  return options.filter(optionGroup => {
    const groupTitle = (optionGroup.groupTitle || "").toLowerCase();
    const header = (optionGroup.header || "").toLowerCase();

    // Remove Gift Box Sleeve option groups
    const isGiftBoxSleeve =
      groupTitle.includes("gift box") || header.includes("gift box");

    // Remove Cake Image option groups
    const isCakeImage = header.includes("cake image");

    return !isGiftBoxSleeve && !isCakeImage;
  });
};

export default filterOutOrderProductOptions;
